import { createFileRoute } from '@tanstack/react-router';

import { ClubEditPage } from '@/components/admin/sport/club-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetClubFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/clubs_/$id')({
    component: ClubEditRoute,
    head: ({ params, loaderData }) =>
        adminHead(
            params.id === 'new'
                ? 'מועדון חדש'
                : (loaderData?.club?.name ?? 'עריכת מועדון'),
            `/admin/sport/clubs/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetClubFn({ data: { id: params.id } });
    },
});

function ClubEditRoute() {
    const data = Route.useLoaderData();
    const key = useAdminEditPageKey(
        data?.club ? `${data.club.id}:${String(data.club.updatedAt)}` : undefined,
    );
    return <ClubEditPage key={key} data={data} />;
}
